import { Component, InputSignal, OutputEmitterRef, input, output, signal, WritableSignal } from '@angular/core';
import { CsIconModule } from '@components/icon';
import { KeyboardInsetDirective } from 'client/directives/keyboard-inset/keyboard-inset.directive';

/**
 * Shared page chrome for the split onboarding profile pages. Its geometry deliberately mirrors
 * `onboarding-concern`, so the doctor and heading stay pinned as the user advances.
 */
@Component({
  selector: 'app-onboarding-profile-shell',
  templateUrl: './onboarding-profile-shell.component.html',
  imports: [CsIconModule, KeyboardInsetDirective],
})
export class OnboardingProfileShellComponent {
  /** False removes the footer from the DOM, so it never renders as an empty white bar. */
  readonly showFooter: InputSignal<boolean> = input(true);
  protected readonly isKeyboardOpen: WritableSignal<boolean> = signal(false);

  protected setKeyboardOpen(isOpen: boolean): void {
    this.isKeyboardOpen.set(isOpen);
  }
}
